// Autogenerated file
export const documentBusinessTypesEnum = {
    AcceptanceCertificate: "AcceptanceCertificate",
    TaxInvoice: "TaxInvoice",
    Invoice: "Invoice",
    Contract: "Contract",
    UniversalTransferDocumentStatus1: "UniversalTransferDocumentStatus1",
    UniversalTransferDocumentStatus2: "UniversalTransferDocumentStatus2",
    RegistryAppendix: "RegistryAppendix",
};
export const documentBusinessTypes = [
    { label: "Акт", value: "AcceptanceCertificate" },
    { label: "Счёт-Фактура", value: "TaxInvoice" },
    { label: "Счёт", value: "Invoice" },
    { label: "Договор", value: "Contract" },
    { label: "УПД со статусом 1", value: "UniversalTransferDocumentStatus1" },
    { label: "УПД со статусом 2", value: "UniversalTransferDocumentStatus2" },
    { label: "Реестр-приложение", value: "RegistryAppendix" },
];
